/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["texture-controls-drawer .texture{margin:0 5px}texture-controls-drawer .texture:first-of-type{margin-left:0}"];
export { styles as styles };
